export default {
    name: 'stafferstype',
    component: () => import(/* webpackChunkName: "stafferstype-Layout" */ '@/modules/stafferstype/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.stafferstype.index',
            component: () => import(/* webpackChunkName: "stafferstype-index" */ '@/modules/stafferstype/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.stafferstype.create',
            component: () => import(/* webpackChunkName: "stafferstype-create" */ '@/modules/stafferstype/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.stafferstype.edit',
            component: () => import(/* webpackChunkName: "stafferstype-edit" */ '@/modules/stafferstype/views/Edit'),
        },
    ]
}